import ModalCustom from "components/ModalCustom"
import ActionFooterModalCard from "components/ModalCustom/ActionFooterModalCard"
import { useEffect, useState } from "react"
import { updateUserRoleMiddleware } from "../api.service"
import { toast } from "react-toastify"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { MESSENGER_NOTIFICATION } from "constants/messenger"
import Tippy from "@tippyjs/react"
import IconInfoCircle from "assets/images/icons/icon-info-circle.svg"
import { addRoleGroupOrganizationMiddleware } from "pages/projects/services/api"

interface Props {
  isOpen: boolean
  roles: { id: string; name: string; description: string }[]
  roleId: string
  userId: string
  onCloseModal: () => void
  onSuccess: () => void
  handleShareKeys: (userId: string) => void
}
export const ChangeRoleModal = (props: Props) => {
  const {
    roles,
    onCloseModal,
    userId,
    onSuccess,
    roleId,
    isOpen,
    handleShareKeys,
  } = props
  const [selectedRole, setSelectedRole] = useState<string>("")

  useEffect(() => {
    if (!isOpen || !roleId) {
      return
    }
    setSelectedRole(roleId)
  }, [roleId, isOpen])

  const handleChangeItem = (id: string) => () => {
    if (selectedRole === id) {
      setSelectedRole("")
      return
    }
    setSelectedRole(id)
  }
  const onSubmit = async () => {
    try {
      const response = await updateUserRoleMiddleware(userId, selectedRole)
      if (response.data.data.is_share_all_project) {
        await addRoleGroupOrganizationMiddleware({
          is_share_all_project: true,
          user_ids: JSON.stringify([userId]),
        })
        handleShareKeys(userId)
      }
      toast(
        <LabelNotificationPage
          messenger={MESSENGER_NOTIFICATION.CHANGE_ROLE_SUCCESS}
          type="success"
        />
      )
      onCloseModal()
      onSuccess()
    } catch (error: any) {
      toast(
        <LabelNotificationPage
          messenger={MESSENGER_NOTIFICATION.CHANGE_ROLE_ERROR}
          type="error"
        />
      )
    }
  }

  const renderBody = () => {
    return (
      <div className="flex flex-col">
        <div className="grid grid-cols-2 gap-2">
          {roles.map((role) => {
            const isActive = role.id === selectedRole
            return (
              <div
                key={role.id}
                className="rounded px-1 cursor-pointer min-h-[32px] flex items-center"
                style={{
                  border: isActive ? "1px solid #F7AC1B" : "1px solid #E4E4E4",
                  boxShadow: isActive
                    ? "0px 0px 0px 4px rgba(247, 172, 27, 0.1)"
                    : "none",
                  backgroundColor: isActive ? "#FFFFFF" : "#F7F7F7",
                }}
                onClick={handleChangeItem(role.id)}
              >
                <p
                  className="font-normal text-center w-full"
                  style={{
                    color: isActive ? "#222222" : "#7A7A7A",
                    fontSize: 14,
                    lineHeight: "24px",
                  }}
                >
                  {role.name}
                </p>
                <Tippy content={role.description}>
                  <img
                    src={IconInfoCircle}
                    alt="icon"
                    className="cursor-pointer pl-2"
                  />
                </Tippy>
              </div>
            )
          })}
        </div>

        <ActionFooterModalCard
          onCloseModal={onCloseModal}
          onSubmit={onSubmit}
          handleDisableButton={selectedRole === "" || selectedRole === roleId}
          titleButton="Yes, share keys"
          styleRoot={{
            marginTop: 20,
          }}
        />
      </div>
    )
  }
  return (
    <ModalCustom
      styleLayout={{
        zIndex: 99,
      }}
      handleChangeButton={() => onCloseModal}
      label="Change Role"
      widthModal={490}
      bodyChildren={renderBody()}
    />
  )
}
